/**
 * Please sort all exports in this file alphabetically!
 */
export { default as H1 } from './H1'
export { default as H2 } from './H2'
export { default as H3 } from './H3'
export { default as H4 } from './H4'
export { default as H5 } from './H5'
export { default as H6 } from './H6'
